import { isHTMLInputElement, isHTMLSelectElement, isHTMLTextareaElement } from "../index.js";
/**
 * Creates an object of event handler functions for native form elements.
 */
export function createFieldHandlers(setValue) {
    return {
        input: (e) => {
            const target = e.target;
            if (!isHTMLInputElement(target) && !isHTMLTextareaElement(target))
                return;
            setValue(target.value);
        },
        checkbox: (e) => {
            const target = e.target;
            if (!isHTMLInputElement(target))
                return;
            setValue(target.checked);
        },
        radio: (e) => {
            const target = e.target;
            if (!isHTMLInputElement(target))
                return;
            if (target.checked)
                setValue(target.value);
        },
        select: (e) => {
            const target = e.target;
            if (!isHTMLSelectElement(target))
                return;
            setValue(target.value);
        }
    };
}
